module.exports = "\r\n<div class=\"basic-form-header text-center\">\r\n  <span class=\"basic-form-heading\" [innerHtml]=\"message\"></span>\r\n</div>\r\n"